import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    margin: '24px 0',
    flexGrow: 1,
  },
});

export default useStyles;
